import React, { ReactNode } from 'react';
import * as S from './ProfileLayout.styled';
import { useDesktopProfileScroll } from './useDesktopProfileScroll';
import { Footer } from '@/components/Footer/Footer';
import { Header } from '@/components/Header';
import { PageTopControls } from '@/components/PageTopControls';
import { TabBar } from '@/components/TabBar/TabBar';
import { MobileProfileHeader } from '@/features/Profile/core/MobileProfileHeader';
import { MobileProfileOverview } from '@/features/Profile/core/MobileProfileOverview';
import { ProfileNav } from '@/features/Profile/core/ProfileNav';
import { UserSummaryCard } from '@/features/Profile/core/UserSummaryCard';
import { useResponsive } from '@/hooks/useResponsive';
import { useUrlAndHashFromPath } from '@/hooks/useUrlAndHashFromPath';
import { WebViewPaymentStatusModal } from '@/components/Payment/WebViewPaymentStatusModal';

type ProfileLayoutProps = {
  children: ReactNode;
  isContentFramed?: boolean;
  mobileHeader?: {
    title: string;
  };
  hideFooter?: boolean;
};

export const ProfileLayout = ({
  children,
  isContentFramed = true,
  mobileHeader,
  hideFooter = false,
}: ProfileLayoutProps) => {
  const { isDesktop } = useResponsive();
  const { clearUrl: currentPath } = useUrlAndHashFromPath();
  const { sidebarRef } = useDesktopProfileScroll(isDesktop);

  return (
    <S.Page>
      {isDesktop && (
        <PageTopControls>
          <Header />
        </PageTopControls>
      )}

      {!isDesktop &&
        (mobileHeader ? (
          <MobileProfileHeader
            title={mobileHeader.title}
            currentPath={currentPath}
          />
        ) : (
          <MobileProfileOverview currentPath={currentPath} />
        ))}

      <S.Main>
        {isDesktop && (
          <S.Sidebar ref={sidebarRef}>
            <UserSummaryCard currentPath={currentPath} />
            <ProfileNav currentPath={currentPath} />
          </S.Sidebar>
        )}

        <S.Content
          $isFramed={isContentFramed}
          $hasCompactHeader={Boolean(mobileHeader)}
        >
          {children}
        </S.Content>
      </S.Main>

      {isDesktop ? (
        <S.DesktopFooter hasRegions={false} />
      ) : (
        !hideFooter && <Footer />
      )}
      {!isDesktop && !hideFooter && <TabBar />}

      <WebViewPaymentStatusModal />
    </S.Page>
  );
};
